import { Badge, Box, Card, Flex, Grid, Group, Text, Tooltip } from '@mantine/core';
import { IconClockCog, IconHistory, IconTicket } from '@tabler/icons-react';
import { useLocation } from 'react-router';

const CouponCard = ({ coupon }) => {
  const location = useLocation();

  return (
    <Card key={coupon.id} mb="lg" withBorder>
      <Card.Section inheritPadding py="sm" bg="white" style={{ textAlign: 'left' }}>
        <Grid>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            <Box>
              <a href={`#${location.pathname}/${coupon.id}/details`}>
                <strong>{coupon.name}</strong>
              </a>
            </Box>
            <Flex gap="xs" mt="xs">
              <Tooltip
                label={
                  <>
                    <div>Created: {new Date(coupon.createdAt).toLocaleString()}</div>
                    <div>Updated: {new Date(coupon.updatedAt).toLocaleString()}</div>
                  </>
                }
                position="top"
                withArrow
              >
                <Badge variant="default" style={{ cursor: 'pointer' }}>
                  <IconHistory size={14} style={{ verticalAlign: 'middle' }} />
                </Badge>
              </Tooltip>
            </Flex>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 4 }}>
            <Group justify="flex-end" c="dimmed">
              {coupon.totalCount === null ? (
                <Text>
                  <IconClockCog /> Importing...
                </Text>
              ) : (
                <>
                  <IconTicket /> Remaining: {coupon.totalCount.toString()}
                </>
              )}
            </Group>
          </Grid.Col>
        </Grid>
      </Card.Section>
    </Card>
  );
};
export default CouponCard;
